<template>
    <div v-if="visible" id="ChangePasswordModal">
        <a-modal :title="modalTitle"
                 :visible="visible"
                 :confirm-loading="confirmLoading"
                 :maskClosable="maskClosable"
                 @ok="handleOk"
                 @cancel="handleCancel"
        >

            <a-row v-if="isShowInvalidMsg">
                <a-col class="errorMsg">
                    Please note your password in accordance with Lenovo security policy, must contain: Capital letter,
                    lower case, number, special characters (i.e. !, @、#、$、%、^、&、*) and ensure between 8 and 20 digit
                    length.
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="7"><span class="inputTitle">Old Password:</span></a-col>
                <a-col :span="16" offset="1">
                    <a-input-password placeholder="input old password" v-model="oldPassword"/>
                    <span v-if="isShowOldPswMsg" class="errorMsg">{{ErrorMsg1}}</span>

                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="7"><span class="inputTitle">New Password:</span></a-col>
                <a-col :span="16" offset="1">
                    <a-input-password placeholder="input new password" v-model="newPassword"/>
                    <span v-if="isShowNewPswMsg" class="errorMsg">{{ErrorMsg2}}</span>

                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="7"><span class="inputTitle">Confirm Password:</span></a-col>
                <a-col :span="16" offset="1">
                    <a-input-password placeholder="input confirm password!" v-model="newPasswordAgain"/>
                    <span v-if="isShowConfirmPswMsg" class="errorMsg">{{ErrorMsg3}}</span>
                </a-col>
            </a-row>
            <template slot="footer">
                <a-button @click="handleCancel" :loading="confirmLoading">
                    Cancel
                </a-button>
                <a-button type="primary" :loading="confirmLoading" @click="handleOk">
                    Submit
                </a-button>
            </template>

            <a-row v-if="showConfirmLevovoMsg">
                <a-col class="errorMsg">Please contact your Lenovo focal if forgot password.</a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
    import {changePassword} from '../api/userApiMethod'

    export default {
        name: "ChangePasswordModal",
        props: ['visible', 'modalTitle'],
        data() {
            return {
                confirmLoading: false,
                showConfirmLevovoMsg: false,
                maskClosable: false,
                oldPassword: '',
                newPassword: '',
                newPasswordAgain: '',
                isShowOldPswMsg: false,
                isShowNewPswMsg: false,
                isShowConfirmPswMsg: false,
                ErrorMsg1: 'Please Input New Password!',
                ErrorMsg2: 'Please Input New Password!',
                ErrorMsg3: 'Please Input New Password!',
                isShowInvalidMsg: false
            }
        },
        destroyed() {
        },
        created() {
        },
        methods: {
            checkPassword() {
                this.isShowInvalidMsg = false
                if (this.oldPassword && this.oldPassword.length > 0) {
                    if (!this.checkPasswordInvaild(this.oldPassword)) {
                        this.isShowOldPswMsg = true
                        if (!this.isShowInvalidMsg) this.isShowInvalidMsg = true
                        this.ErrorMsg1 = 'Invalid password format！'
                    } else {
                        this.isShowOldPswMsg = false
                    }
                } else {
                    this.isShowOldPswMsg = true
                    this.ErrorMsg1 = 'Please Input New Password!'
                }
                if (this.newPassword && this.newPassword.length > 0) {
                    if (!this.checkPasswordInvaild(this.newPassword)) {
                        this.isShowNewPswMsg = true
                        this.ErrorMsg2 = 'Invalid password format！'
                        if (!this.isShowInvalidMsg) this.isShowInvalidMsg = true
                    } else {
                        this.isShowNewPswMsg = false
                    }
                } else {
                    this.isShowNewPswMsg = true
                    this.ErrorMsg2 = 'Please Input New Password!'
                }

                if (this.newPasswordAgain && this.newPasswordAgain.length > 0) {
                    if (!this.checkPasswordInvaild(this.newPasswordAgain)) {
                        this.isShowConfirmPswMsg = true
                        this.ErrorMsg3 = 'Invalid password format！'
                        if (!this.isShowInvalidMsg) this.isShowInvalidMsg = true
                    } else {
                        this.isShowConfirmPswMsg = false
                        this.ErrorMsg3 = 'Please Input New Password!'
                    }
                } else {
                    this.isShowConfirmPswMsg = true
                    this.ErrorMsg3 = 'Please Input New Password!'
                }
                if (!this.isShowOldPswMsg && !this.isShowConfirmPswMsg && !this.isShowNewPswMsg) {
                    return true
                }
                return false
            },
            handleOk() {
                if (this.checkPassword()) {
                    const param = {
                        oldPassword: this.$md5(this.oldPassword),
                        newPassword: this.$md5(this.newPassword),
                        confirmPassword: this.$md5(this.newPasswordAgain),
                    }
                    this.confirmLoading = true
                    changePassword(param).then(res => {
                        this.confirmLoading = false
                        const err = res['errors']
                        const war = res['warnings']
                        if ((err && err.length > 0) || (war && war.length > 0)) {
                            var msg = err[0] ? err[0] : (war[0] ? war[0] : 'Error')
                            this.showConfirmLevovoMsg = true

                            this.$error({
                                title: 'Error',
                                content: msg,
                            });
                        } else {
                            this.$emit('confirm', res)
                        }

                    }).catch(() => {
                        this.confirmLoading = false
                        this.showConfirmLevovoMsg = true
                    })
                }
            },
            handleCancel() {
                this.$emit('cancel')

            },
            checkPasswordInvaild(e) {
                /*
                * 1.密码必须由字母、数字、特殊符号组成，区分大小写
                * 2.特殊符号包含（,、@、#、$、%、^、&、*）
                * 3.密码长度为8-20位
                * */

            // `~!@#$^&*()=|{}':;',\\[\\].<>/?
                // var reg = /^(?![a-zA-Z]+$)(?![0-9]+$)(?![._~!@#$^&*]+$)(?![0-9a-zA-Z]+$)(?![0-9._~!@#$^&*]+$)(?![a-zA-Z._~!@#$^&*]+$)[A-Za-z0-9._~!@#$^&*]{8,20}$/
                var reg = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!,@#$^%&*])[A-Za-z0-9!,@#$^%&*]{8,20}$/
                if (reg.test(e)) {
                    return true
                } else {
                    return false
                }
            }
        }
    }
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    .inputTitle {
        font-size: 14px;
        line-height: 30px;
        color: #555555;
    }

    .errorMsg {
        margin-top: 4px;
        text-align: left;
        color: red;
    }

</style>
